module.exports = "<div class=modal-body style=padding:0> <iframe id=kps-payment-frame style=padding:15px;border-radius:5px></iframe> </div>";